var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tile is-ancestor is-parent" },
    [
      _c("div", { staticClass: "tile is-parent" }, [
        _c(
          "article",
          { staticClass: "tile is-child box" },
          [
            _c("div", { staticClass: "columns is-gapless" }, [
              _vm._m(0),
              _c("div", { staticClass: "column is-narrow" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.connectedQuoteNos.length > 0,
                        expression: "connectedQuoteNos.length > 0",
                      },
                    ],
                    staticClass: "tags has-addons",
                  },
                  [
                    _c("span", { staticClass: "tag is-dark" }, [
                      _vm._v("Quote Nos"),
                    ]),
                    _c("span", { staticClass: "tag is-info" }, [
                      _vm._v(_vm._s(_vm.connectedQuoteNos.join(","))),
                    ]),
                  ]
                ),
              ]),
            ]),
            _c("div", { staticClass: "columns is-gapless" }, [
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Rego")]),
                  _c(
                    "div",
                    {
                      staticClass: "field is-narrow has-validation has-addons",
                    },
                    [
                      _c("div", { staticClass: "control" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.entity.rego,
                              expression: "entity.rego",
                            },
                            {
                              name: "fq-validate",
                              rawName: "v-fq-validate",
                              value: _vm.$v.entity.rego,
                              expression: "$v.entity.rego",
                            },
                          ],
                          ref: "rego",
                          staticClass: "input is-uppercase rego",
                          attrs: { type: "text", placeholder: "Rego" },
                          domProps: { value: _vm.entity.rego },
                          on: {
                            keyup: _vm.checkRego,
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(_vm.entity, "rego", $event.target.value)
                            },
                          },
                        }),
                        !_vm.$v.entity.rego.required
                          ? _c("span", { staticClass: "help is-danger" }, [
                              _vm._v("Rego is required"),
                            ])
                          : _vm._e(),
                        _vm.regoInUse
                          ? _c("span", { staticClass: "help is-warning" }, [
                              _vm._v("Rego already exists"),
                            ])
                          : _vm._e(),
                      ]),
                      _vm.$company.info.countryCode === "AU"
                        ? _c("div", { staticClass: "control" }, [
                            _c(
                              "button",
                              {
                                staticClass: "button is-primary tooltip",
                                attrs: {
                                  "data-tooltip": "Rego lookup service",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.isVehicleLookupModalActive = true
                                  },
                                },
                              },
                              [_vm._m(1)]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
              ]),
              _vm.$company.info.countryCode === "AU"
                ? _c("div", { staticClass: "column" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("label", { staticClass: "label" }, [_vm._v("State")]),
                      _c("div", { staticClass: "control is-extended" }, [
                        _c("div", { staticClass: "select is-narrow" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.entity.stateRego,
                                  expression: "entity.stateRego",
                                },
                              ],
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.entity,
                                    "stateRego",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "option",
                                { attrs: { value: "null", disabled: "" } },
                                [_vm._v("Select")]
                              ),
                              _vm._l(_vm.stateRegoTypes, function (a, b) {
                                return _c(
                                  "option",
                                  { key: b, domProps: { value: b } },
                                  [_vm._v(_vm._s(a))]
                                )
                              }),
                            ],
                            2
                          ),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _c("vehicle-customer", {
              model: {
                value: _vm.entity.customer,
                callback: function ($$v) {
                  _vm.$set(_vm.entity, "customer", $$v)
                },
                expression: "entity.customer",
              },
            }),
            _c("vehicle-model", { attrs: { entity: _vm.entity } }),
            _c("div", { staticClass: "is-divider" }),
            _c("div", { staticClass: "columns" }, [
              _c("div", { staticClass: "column" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Body Style")]),
                _c("div", { staticClass: "field has-addons" }, [
                  _c("div", { staticClass: "control" }, [
                    _c(
                      "div",
                      {
                        staticClass: "select",
                        class: { "is-danger": _vm.$v.entity.bodyId.$error },
                      },
                      [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.entity.bodyId,
                                expression: "entity.bodyId",
                              },
                            ],
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.entity,
                                    "bodyId",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                _vm.bodyChanged,
                              ],
                            },
                          },
                          [
                            _c(
                              "option",
                              { attrs: { value: "null", disabled: "" } },
                              [_vm._v("Select")]
                            ),
                            _vm._l(_vm.bodyStyles, function (s, index) {
                              return _c(
                                "option",
                                { key: index, domProps: { value: s.id } },
                                [_vm._v(" " + _vm._s(s.name) + " ")]
                              )
                            }),
                          ],
                          2
                        ),
                      ]
                    ),
                    !_vm.$v.entity.bodyId.required
                      ? _c("span", { staticClass: "help is-danger" }, [
                          _vm._v("Required"),
                        ])
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "control" }, [
                    _c(
                      "div",
                      {
                        staticClass: "select",
                        class: { "is-danger": _vm.$v.entity.bodyId2.$error },
                      },
                      [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.entity.bodyId2,
                                expression: "entity.bodyId2",
                              },
                            ],
                            ref: "bodyId2",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.entity,
                                  "bodyId2",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "option",
                              { attrs: { value: "null", disabled: "" } },
                              [_vm._v("Select")]
                            ),
                            _vm._l(_vm.bodyStyles2, function (s, index) {
                              return _c(
                                "option",
                                { key: index, domProps: { value: s.id } },
                                [_vm._v(" " + _vm._s(s.name) + " ")]
                              )
                            }),
                          ],
                          2
                        ),
                      ]
                    ),
                    !_vm.$v.entity.bodyId2.required
                      ? _c("span", { staticClass: "help is-danger" }, [
                          _vm._v("Required"),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _c("label", { staticClass: "label" }, [_vm._v("Built")]),
                _c("div", { staticClass: "field has-addons" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("div", { staticClass: "select" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.entity.buildMonth,
                              expression: "entity.buildMonth",
                            },
                          ],
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.entity,
                                "buildMonth",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            { attrs: { value: "null", disabled: "" } },
                            [_vm._v("MM")]
                          ),
                          _vm._l(_vm.months, function (value, key) {
                            return _c(
                              "option",
                              { key: key, domProps: { value: key } },
                              [_vm._v(_vm._s(value))]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                  ]),
                  _c(
                    "p",
                    { staticClass: "control" },
                    [
                      _c("the-mask", {
                        staticClass: "input",
                        attrs: { placeholder: "Year", mask: ["####"] },
                        nativeOn: {
                          blur: function ($event) {
                            return _vm.checkYear.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.entity.buildYear,
                          callback: function ($$v) {
                            _vm.$set(_vm.entity, "buildYear", $$v)
                          },
                          expression: "entity.buildYear",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "field-body" }, [
                    _c("div", { staticClass: "field is-narrow" }, [
                      _c("div", { staticClass: "control" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Transmission"),
                        ]),
                        _c("div", { staticClass: "select" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.entity.transmissionType,
                                  expression: "entity.transmissionType",
                                },
                              ],
                              staticClass: "control-min-width",
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.entity,
                                    "transmissionType",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "option",
                                { attrs: { value: "null", disabled: "" } },
                                [_vm._v("Select")]
                              ),
                              _vm._l(_vm.transmissionTypes, function (a, b) {
                                return _c(
                                  "option",
                                  { key: b, domProps: { value: b } },
                                  [_vm._v(_vm._s(a))]
                                )
                              }),
                            ],
                            2
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Paint Group"),
                  ]),
                  _c("div", { staticClass: "is-flex" }, [
                    _c("div", { staticClass: "control" }, [
                      _c(
                        "div",
                        {
                          staticClass: "select",
                          class: {
                            "is-danger": _vm.$v.entity.paintGroup.$error,
                          },
                        },
                        [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.entity.paintGroup,
                                  expression: "entity.paintGroup",
                                },
                              ],
                              ref: "paintGroup",
                              staticClass: "control-min-width",
                              on: {
                                change: [
                                  function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.entity,
                                      "paintGroup",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function ($event) {
                                    return _vm.selectPaintGroup($event)
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "option",
                                { attrs: { value: "null", disabled: "" } },
                                [_vm._v("Select")]
                              ),
                              _vm._l(_vm.paintGroups, function (p, index) {
                                return _c(
                                  "option",
                                  { key: index, domProps: { value: p.key } },
                                  [_vm._v(" " + _vm._s(p.value) + " ")]
                                )
                              }),
                            ],
                            2
                          ),
                        ]
                      ),
                      !_vm.$v.entity.paintGroup.required
                        ? _c("span", { staticClass: "help is-danger" }, [
                            _vm._v("Paint group is required"),
                          ])
                        : _vm._e(),
                    ]),
                    _vm.entity.paintGroup === _vm.paintGroupTypes.M3
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "control is-flex is-align-items-center pl-4",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "pretty p-icon p-curve p-smooth" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.entity.paintGroupPlus,
                                      expression: "entity.paintGroupPlus",
                                    },
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.entity.paintGroupPlus
                                    )
                                      ? _vm._i(
                                          _vm.entity.paintGroupPlus,
                                          null
                                        ) > -1
                                      : _vm.entity.paintGroupPlus,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.entity.paintGroupPlus,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.entity,
                                              "paintGroupPlus",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.entity,
                                              "paintGroupPlus",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.entity,
                                          "paintGroupPlus",
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                }),
                                _vm._m(2),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "field-body" }, [
                    _c("div", { staticClass: "field is-narrow" }, [
                      _c("label", { staticClass: "label" }, [_vm._v("Colour")]),
                      _c(
                        "p",
                        { staticClass: "control" },
                        [
                          _c("bulma-autocomplete", {
                            staticClass: "is-capitalized control-min-width",
                            attrs: {
                              data: _vm.colours,
                              "keep-first": true,
                              expanded: true,
                            },
                            model: {
                              value: _vm.entity.colour,
                              callback: function ($$v) {
                                _vm.$set(_vm.entity, "colour", $$v)
                              },
                              expression: "entity.colour",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "field-body" }, [
                    _c("div", { staticClass: "field is-narrow" }, [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("Odometer"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "control is-narrow" },
                        [
                          _c("vue-numeric", {
                            staticClass: "input control-min-width",
                            attrs: {
                              maxlength: "10",
                              min: 0,
                              max: 9999999999,
                              "empty-value": null,
                              separator: "",
                              placeholder: "Odometer",
                              precision: 0,
                            },
                            model: {
                              value: _vm.entity.odometer,
                              callback: function ($$v) {
                                _vm.$set(_vm.entity, "odometer", $$v)
                              },
                              expression: "entity.odometer",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm.$user.hasDelete(_vm.$route.meta.id)
              ? _c("div", { staticClass: "is-divider" })
              : _vm._e(),
            _vm.$user.hasDelete(_vm.$route.meta.id)
              ? _c("div", { staticClass: "buttons has-addons is-centered" }, [
                  _c(
                    "span",
                    {
                      staticClass: "button",
                      class: { "is-success is-selected": _vm.entity.isActive },
                      on: {
                        click: function ($event) {
                          return _vm.toggleActive(true)
                        },
                      },
                    },
                    [_vm._m(3), _c("span", [_vm._v("Active")])]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "button",
                      class: { "is-danger is-selected": !_vm.entity.isActive },
                      on: {
                        click: function ($event) {
                          return _vm.toggleActive(false)
                        },
                      },
                    },
                    [_vm._m(4), _c("span", [_vm._v("In-Active")])]
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "tile is-vertical is-3" }, [
        _c(
          "div",
          { staticClass: "tile is-parent" },
          [
            _c("vehicle-engine", {
              staticClass: "tile is-child box",
              attrs: { entity: _vm.entity },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "tile is-parent" }, [
          _c("article", { staticClass: "tile is-child box" }, [
            _c("p", { staticClass: "title" }, [_vm._v("Codes")]),
            _c("div", { staticClass: "field is-narrow" }, [
              _c(
                "label",
                { staticClass: "label", attrs: { for: "trimcode" } },
                [_vm._v("Trim Code")]
              ),
              _c("p", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.entity.trimCode,
                      expression: "entity.trimCode",
                    },
                  ],
                  staticClass: "input",
                  attrs: { id: "trimcode", type: "text", placeholder: "S" },
                  domProps: { value: _vm.entity.trimCode },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.entity, "trimCode", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "field is-narrow" }, [
              _c(
                "label",
                { staticClass: "label", attrs: { for: "optioncode" } },
                [_vm._v("Option Code")]
              ),
              _c("p", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.entity.optionCode,
                      expression: "entity.optionCode",
                    },
                  ],
                  staticClass: "input",
                  attrs: { id: "optioncode", type: "text", placeholder: "O" },
                  domProps: { value: _vm.entity.optionCode },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.entity, "optionCode", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "field is-narrow" }, [
              _c(
                "label",
                { staticClass: "label", attrs: { for: "toyotamodelno" } },
                [_vm._v("Toyota Model No")]
              ),
              _c("p", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.entity.toyotaModelNo,
                      expression: "entity.toyotaModelNo",
                    },
                  ],
                  staticClass: "input",
                  attrs: {
                    id: "toyotamodelno",
                    type: "text",
                    placeholder: "e.g. ABC123",
                  },
                  domProps: { value: _vm.entity.toyotaModelNo },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.entity, "toyotaModelNo", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "field is-narrow" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Paint Code")]),
              _c("p", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.entity.paintCode,
                      expression: "entity.paintCode",
                    },
                  ],
                  staticClass: "input",
                  attrs: { type: "text", placeholder: "#" },
                  domProps: { value: _vm.entity.paintCode },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.entity, "paintCode", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm.isVehicleLookupModalActive
        ? _c(
            "vehicle-lookup-modal",
            {
              attrs: {
                active: _vm.isVehicleLookupModalActive,
                "state-rego": _vm.entity.stateRego,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isVehicleLookupModalActive = $event
                },
                close: function ($event) {
                  return _vm.closeVehicleLookupModal()
                },
                select: _vm.select,
              },
              model: {
                value: _vm.entity.rego,
                callback: function ($$v) {
                  _vm.$set(_vm.entity, "rego", $$v)
                },
                expression: "entity.rego",
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Make/Model Lookup"),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Details")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-magnify mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label", [_vm._v("M3+")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-close" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }